import _extends from "@babel/runtime/helpers/extends";
import Box from "@material-ui/core/esm/Box";
import TextField from "@material-ui/core/esm/TextField";
import Typography from "@material-ui/core/esm/Typography";
import Autocomplete from "@material-ui/lab/esm/Autocomplete";
import { nanoid } from 'nanoid';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormElement } from 'components/Form';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from '../VehicleFormStyles';
import CLASSIFICATION_ENGLISH from './classification_codes_en.json';
import CLASSIFICATION_NORWEGIAN from './classification_codes_no.json';
const idSuffix = nanoid();
export const classificationFieldName = 'classification';
export default function Classification({
  control
}) {
  const {
    classificationBox
  } = useStyles();
  const {
    t,
    i18n
  } = useTranslation();
  const [classificationList, setClassificationList] = useState(CLASSIFICATION_NORWEGIAN);
  const {
    trigger
  } = useFormContext();
  const getCodes = Object.keys(classificationList);
  useEffect(() => {
    return isNorwegian(i18n) ? setClassificationList(CLASSIFICATION_NORWEGIAN) : setClassificationList(CLASSIFICATION_ENGLISH);
  }, [i18n]);
  const inputId = `${classificationFieldName}_${idSuffix}`;
  return /*#__PURE__*/React.createElement(FormElement, {
    title: t('vehicles.classification'),
    childId: inputId
  }, /*#__PURE__*/React.createElement(Controller, {
    name: classificationFieldName,
    defaultValue: null,
    control: control,
    rules: {
      required: true
    },
    render: ({
      onChange,
      onBlur,
      ...props
    }) => /*#__PURE__*/React.createElement(Autocomplete, _extends({
      defaultValue: null,
      placeholder: t('vehicles.classification'),
      options: getCodes,
      getOptionLabel: option => option,
      onChange: (_e, data) => {
        onChange(data);
        trigger('size');
      },
      onBlur: onBlur,
      style: {
        width: 300
      },
      renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: t('vehicles.classification'),
        variant: "outlined",
        InputProps: {
          ...params.InputProps,
          endAdornment: params.InputProps.endAdornment
        }
        // eslint-disable-next-line react/jsx-no-duplicate-props
        ,
        inputProps: {
          ...params.inputProps,
          id: inputId
        }
      })),
      renderOption: option => /*#__PURE__*/React.createElement(Box, {
        className: classificationBox
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1"
      }, option), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption"
      }, option ? classificationList[option].codeDescription : ''))
    }, props))
  }));
}